<script>
import './style.scss';
import {RhombusIcon, CalendarCheckIcon} from '../icons.js';
import template from './template.html';

export default {

    template,

    props: {
        title: {
            default: '',
            type: String
        },

        status: {
            default: 'Active',
            type: String
        },

        statusColor: {
            default: '#eee',
            type: String
        },

        navigation: {
            default: [],
            type: Array
        }
    },

    created() {
    },

    computed: {
        statusTitleCase() {
            return this.titleCase(this.status);
        }
    },

    methods: {
        titleCase(str = '') {
            return str.replace(/\w\S*/g, function (txt) {
                return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
            });
        },
    },

    data() {

        return {}
    },

    components: {
        CalendarCheckIcon
        , RhombusIcon
    }
};
</script>
